import axios from 'axios'
import { Toast } from 'antd-mobile';
import { AxiosRequestConfig, HttpResquest } from '@src/types/http'
import { routerStore } from '@store/routerStore'
import { LANG } from '@src/constants'
import { getLang } from '@src/utils'
import intl from '@utils/intl';

enum HTTPERROR {
    LOGICERROR,
    TIMEOUTERROR,
    NETWORKERROR
}

const pagingUrls = [
    '/pay/payRecord',
    '/pay/hasInvoicePayRecord',
    '/pay/historyInvoiceRecord',
    '/integral/integralRecordList',
    '/question/queryMyQuestion',
]
const interceptorUrls = [
    '/activity/draw',
    '/podpage/queryStreamCouponInfo',
    '/podpage/verifyMsgCode',
    '/podpage/sendMsg',
    '/podpage/receiveCouponCode',
    'https://aoac.lenovoconnect.com/sim/queryGoodsShelfInfo',
    'https://aoac.lenovoconnect.com/sim/simInfo',
    'https://aoac.lenovoconnect.com/sim/obtainTerminalUsage'
]
const blodUrls = [
    '/ai/chatMsgStream',
]
let showAuthError = false
const queue = []

const DEFAULTCONFIG = {
    baseURL: process.env.BASEURL
}

const http: HttpResquest = {}
const methods = ['get', 'post', 'put', 'delete']

const isSuccess = res => res.success
const resFormat = res => res.response || res.data || {}

const interceptors = response => {
    if (!showAuthError && response.data.code === '7000') {
        showAuthError = true
        setTimeout(() => {
            showAuthError = false
            location.href = '#/login'
        }, 300)
        return Promise.resolve(null)
    }
    if (response.data.code === 401) {
        return Promise.reject({
            code: response.data.code,
            msg: '您没有权限访问'
        })
    }
    if (response.data.code === 1022 || response.data.code === '1022') {
        location.href = '#/app/home'
    }
}
// 海外拦截
const globalInterceptors = (response) => {
    if (response.data.code === '7000') {
        localStorage.removeItem('userInfo')
        location.href = '#/global/login'
        return Promise.resolve(null)
    }
}

// 添加 esim 拦截器
const esimInterceptors = (response) => {
    if (response.data.code === '7000') {
        localStorage.removeItem('userInfo');
        location.href = '#/esim/login'
        return Promise.resolve(null);
    }
};

methods.forEach(v => {
    http[v] = (url, data, baseUrl?) => {
        Object.keys(data).map(item => {
            data[item] = !!data[item] && typeof data[item] === 'string' ? data[item].trim() : data[item]
            if (data[item] === '') {
                delete data[item]
            }
        })
        const axiosConfig: AxiosRequestConfig = {
            method: v,
            url,
            baseURL: baseUrl || DEFAULTCONFIG.baseURL
        }
        const instance = axios.create(DEFAULTCONFIG)
        instance.interceptors.request.use(
            cfg => {
                const ts = Date.now() / 1000
                const queryData = {
                    ts,
                }
                cfg.params = {
                    ...cfg.params,
                    ...queryData
                }
                if (blodUrls.includes(url)) {
                    // cfg.headers['Content-Type'] = 'multipart/form-data;charset=UTF-8'
                    cfg.responseType = 'text/event-stream'
                } else {
                    cfg.headers['Content-Type'] = 'application/json;charset=UTF-8'
                }
                cfg.headers['X-Requested-With'] = 'XMLHttpRequest'
                cfg.headers['toKey'] = localStorage.toKey || ''
                cfg.headers['lang'] = location.href.includes('global') ? LANG[getLang()] : '1'
                if (pagingUrls.indexOf(url) > -1) {
                    cfg.headers['X-Requested-Paging'] = 'PagingHttpRequest'
                }
                return cfg
            },
            error => Promise.reject(error)
        )
        // Add a response interceptor
        instance.interceptors.response.use(
            response => {
                if (blodUrls.includes(url)) {
                    return response.data
                }
                // 如果url不带global（海外），走国内的拦截器
                if (location.href.includes('esim')) {
                    esimInterceptors(response)
                } else if (location.href.includes('global')) {
                    globalInterceptors(response)
                } else {
                    interceptors(response)
                }

                // 设置返回数据
                let rdata = null
                if (typeof response.data === 'object' && !isNaN(response.data.length)) {
                    rdata = response.data[0]
                } else {
                    rdata = response.data
                }
                if (!isSuccess(rdata)) {
                    const _err = {
                        msg: rdata.msg,
                        code: rdata.code,
                        iCode: rdata.iCode,
                        type: HTTPERROR[HTTPERROR.LOGICERROR],
                        config: response.config
                    }
                    return Promise.reject(_err)
                }
                if (url.includes('syncQuestionnaire')) {
                    return rdata
                }
                return resFormat(rdata)
            },
            error => {
                const _err = {
                    msg: error.message || '网络故障',
                    type: /^timeout of/.test(error.message)
                        ? HTTPERROR[HTTPERROR.TIMEOUTERROR]
                        : HTTPERROR[HTTPERROR.NETWORKERROR],
                    config: error.config
                }
                return Promise.reject(_err)
            }
        )
        if (v === 'get') {
            axiosConfig.params = data
        } else if (data instanceof FormData) {
            axiosConfig.data = data
        } else {
            axiosConfig.data = data
        }
        axiosConfig.startTime = new Date()
        routerStore.setLoading(true)
        queue.length = 0
        return instance
            .request(axiosConfig)
            .then(res => {
                routerStore.setLoading(false)
                return res
            })
            .catch(err => {
                routerStore.setLoading(false)
                if (err.code !== '7000') {
                    const errorMsg = err.msg && err.msg.indexOf('</') > 0
                        ? {
                            title: '错误',
                            content: err.msg
                        } : {
                            title: '错误',
                            content: err.response || err.msg || err.stack || '系统异常'
                        }
                    queue.push(errorMsg)
                    if (queue.length === 1 && !interceptorUrls.includes(url)) {
                        if (!location.href.includes('global')) {
                            Toast.info(err.msg || '接口错误')
                        } else {
                            Toast.info(intl.formatMessage({ id: err.iCode ? `iCode.${err.iCode}` : 'common.unKnowError' }))
                        }
                    }
                    if (axiosConfig.url.includes('autoScript.set')) {
                        return Promise.resolve({
                            err
                        })
                    } else {
                        return Promise.reject({
                            err,
                            stack: err.msg || err.stack || ''
                        })
                    }
                }
            })
    }
})

export default http
